var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "form-group"]
var hoisted2 = ["class", "checkbox-inline"]
var hoisted3 = ["type", "checkbox"]
var hoisted4 = ["class", "form-group"]
var hoisted5 = ["for", "ref"]
var hoisted6 = ["id", "ref", "class", "form-control input-sm"]
var __target

module.exports = function description (model, root) {
  elementOpen("div", "18318876-920e-4f1c-9661-2be40de78e02", hoisted1)
    elementOpen("div")
      elementOpen("label", "6b6875c4-e636-427f-a60d-97c08aac18a0", hoisted2)
        elementOpen("input", "e64be724-0367-4441-902c-75a544affb3c", hoisted3, "checked", model.required, "onchange", function ($event) {
          var $element = this;
        model.required = this.checked})
        elementClose("input")
        text(" Required \
              ")
      elementClose("label")
    elementClose("div")
  elementClose("div")
  elementOpen("div", "1811b3e4-2b80-4cfa-be1b-81903997b811", hoisted4)
    elementOpen("label", "122d19ae-7979-4094-9c71-2c18226a84ec", hoisted5)
      text("Ref")
    elementClose("label")
    elementOpen("select", "683c9be2-bbc5-44a2-98dd-ddbffa05184e", hoisted6, "value", model.ref, "onchange", function ($event) {
      var $element = this;
    model.ref = this.value})
      elementOpen("option")
      elementClose("option")
      __target = root.availableChildDocumentRefs()
      if (__target) {
        ;(__target.forEach ? __target : Object.keys(__target)).forEach(function($value, $item, $target) {
          var schema = $value
          var $key = "62e0a28e-a8e9-4698-ad08-586a66b3d33c_" + $item
          elementOpen("option", $key, null, "value", schema.id, "selected", model.ref === schema.id ? 'selected' : null)
            text("" + (schema.name) + "")
          elementClose("option")
        }, this)
      }
    elementClose("select")
  elementClose("div")
}
